import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

    const Producto = ({ setModalVisibleAPP, prod, agregarAlCarrito, montoMinimoEnvio = 31000, prioridad = false }) => {
    const [cantidad, setCantidad] = useState(1);
    const [modalVisible, setModalVisible] = useState(false);
    //const precioDescuento = (prod.precio < 3000 ? (Math.ceil((prod.precio * 0.9) / 10) * 10):(Math.ceil((prod.precio * 0.9) / 100) * 100));
    const precioDescuento = (Math.ceil((prod.precio * 0.9) / 100) * 100);

    // Formatear los precios correctamente
    const formatoPrecio = (precio) => {
        return new Intl.NumberFormat("es-ES", {
          minimumFractionDigits: 0,
          useGrouping: true
        }).format(Number(precio));
      };

    const aumentarCantidad = () => setCantidad(cantidad + 1);
    const disminuirCantidad = () => cantidad > 1 && setCantidad(cantidad - 1);

    const agregarProducto = () => {
        agregarAlCarrito(prod, cantidad);
        setCantidad(1); // Restablecer la cantidad a 1 después de agregar
    };

    const cerrarModal = (e) => {
        if (e.target.classList.contains("modal")) {
            setModalVisible(false);
            setModalVisibleAPP(false);
        }
    };

    // Cerrar con tecla Escape y bloquear el scroll del fondo mientras el modal está abierto
    useEffect(() => {
        if (!modalVisible) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                setModalVisible(false);
                setModalVisibleAPP(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        const scrollPrevio = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = scrollPrevio;
        };
    }, [modalVisible, setModalVisibleAPP]);


    return (
        <div className="producto">
            <div className="producto-img-wrap">
                {precioDescuento >= montoMinimoEnvio && (
                    <span className="badge-envio-gratis">🚚 Envío Gratis</span>
                )}
                <img
                    src={"imgBL/150x150/"+prod.url_img}
                    width = "150px"
                    height= "150px"
                    alt={prod.nombre}
                    loading={prioridad ? "eager" : "lazy"}
                    fetchPriority={prioridad ? "high" : "auto"}
                    style={{
                        backgroundColor: "#fff",
                        objectFit: "contain"
                    }} onClick={() => {setModalVisible(true); setModalVisibleAPP(true)}} 
                       onError={(e) => {
                        e.target.src = "imgBL/150x150/Imagen default limpi.webp"; // imagen por defecto
                      }}
                     />
            </div>
            <div className="producto-detalle">
                <p className="item-name" onClick={() =>{setModalVisible(true); setModalVisibleAPP(true)}} style={{ cursor: "pointer" }}>{prod.nombre}</p>
                <div className="precio-bloque">
                    <span className="precio-lista">Precio de lista ${formatoPrecio(prod.precio)}</span>
                    <div className="precio-transferencia">
                        <span className="precio-transferencia-valor">${formatoPrecio(precioDescuento)}</span>
                        <span className="precio-transferencia-label">Transferencia o efectivo</span>
                    </div>
                </div>

                <div className="cantidad-selector">
                    <div className="cantidad-group">
                        <button onClick={disminuirCantidad}>➖</button>
                        <div className="cantidad-numero">
                        <span>{cantidad}</span>
                        </div>
                        <button onClick={aumentarCantidad}>➕</button>
                    </div>
                </div>
                <button className="boton-agregar" onClick={agregarProducto}>Agregar</button>
                <button className="boton-ver" onClick={() =>{setModalVisible(true); setModalVisibleAPP(true)}} >Ver</button>
            </div>

            {modalVisible && ReactDOM.createPortal(
            <div className="modal" onClick={cerrarModal}>
                <div className="modal-contenido" onClick={(e) => e.stopPropagation()}>
                {/* Botón de cierre arriba a la derecha */}
                <button
                    className="modal-close"
                    onClick={() => {
                    setModalVisible(false);
                    setModalVisibleAPP(false);
                    }}
                >
                    ✖
                </button>

                <div className="modal-scroll">
                <div>
                    <h2>{prod.nombre}</h2>
                </div>
                <div className="modal-img-wrap">
                {precioDescuento >= montoMinimoEnvio && (
                    <span className="badge-envio-gratis">🚚 Envío Gratis</span>
                )}
                <img
                    src={"imgBL/300x300/" + prod.url_img}
                    width="300px"
                    height="300px"
                    alt={prod.nombre}
                    loading="lazy"
                    style={{
                    backgroundColor: "#fff",
                    objectFit: "contain"
                    }}
                    onError={(e) => {
                        e.target.src = "imgBL/300x300/Imagen default limpi.webp"; // imagen por defecto
                      }}
                />
                </div>
                <p className="producto-descripcion" dangerouslySetInnerHTML={{ __html: prod.descripcion }}></p>
                <div>
                    <div className="precio-bloque">
                        <span className="precio-lista">Precio de lista ${formatoPrecio(prod.precio)}</span>
                        <div className="precio-transferencia">
                            <span className="precio-transferencia-valor">${formatoPrecio(precioDescuento)}</span>
                            <span className="precio-transferencia-label">Transferencia o efectivo</span>
                        </div>
                    </div>

                    <div className="cantidad-selector">
                    <button onClick={disminuirCantidad}>➖</button>
                    <span>{cantidad}</span>
                    <button onClick={aumentarCantidad}>➕</button>
                    </div>
                    <button className="boton-agregar" onClick={agregarProducto}>
                    Agregar
                    </button>
                </div>
                <button
                    className="boton-cerrar"
                    onClick={() => {
                    setModalVisible(false);
                    setModalVisibleAPP(false);
                    }}
                >
                    Cerrar
                </button>
                </div>
                </div>
            </div>,
            document.body
            )}
        </div>
    );
};

export default React.memo(Producto);